var EventStream = require('./lib/event_stream');
module.exports = new EventStream();



//////////////////
// WEBPACK FOOTER
// ./~/eventing-bus/index.js
// module id = 314
// module chunks = 0